import { AuthCallbackPage } from '@mdvip/shared/components/shared/AuthCallbackPage';
import { IdleTimeoutManager } from '@mdvip/shared/components/shared/IdleTimeoutManager';
import { LoginPage } from '@mdvip/shared/components/shared/LoginPage';
import { Toaster } from '@mdvip/shared/components/ui/toaster';
import { getHealthUrl } from '@mdvip/shared/types/config';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { OfflineIndicator } from './components/shared/OfflineIndicator';
import { ProtectedRoute } from './components/shared/ProtectedRoute';
import { useConfig } from './contexts/ConfigContext';
import { DashboardPage } from './pages/DashboardPage';
import { MyProfilePage } from './pages/MyProfilePage';
import { PaymentsPage } from './pages/payments/PaymentsPage';
import { ResourcesPage } from './pages/ResourcesPage';
import { SimpleMessagesPage } from './pages/SimpleMessagesPage';

function App() {
  const config = useConfig();

  return (
    <>
      <IdleTimeoutManager
        idleTimeoutMs={config.IDLE_TIMEOUT_MS}
        warningDurationMs={config.WARNING_DURATION_MS}
        tokenRefreshThreshold={config.TOKEN_REFRESH_THRESHOLD}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage healthUrl={getHealthUrl(config)} postLoginRedirect="/" />} />
          <Route path="/auth/callback" element={<AuthCallbackPage postLoginRedirect="/" />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <MyProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/messages"
            element={
              <ProtectedRoute>
                <SimpleMessagesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/resources"
            element={
              <ProtectedRoute>
                <ResourcesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <ProtectedRoute>
                <PaymentsPage />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster />
        <OfflineIndicator />
      </BrowserRouter>
    </>
  );
}

export default App;
